// import React from "react";
// import ImagesUrl from "#constants/images.js";

// const FileAttachmentComponent = ({
//   label,
//   files,
//   fileInputRef,
//   handleFileChange,
//   handleFileClick,
//   handleFileRemove,
//   handelChange,
//   name,
//   placeholder,
//   onBlur,
//   value,
//   touched,
//   error,
// }) => {
//   return (
//     <>
//       <h3 className="fs-6 fw-medium mb-2">{label}</h3>
//       <div className="mdl_custom_textarea_field">
//         <div className="form-block">
//           <textarea
//             id="observation"
//             className="form-control"
//             placeholder={placeholder}
//             value={value}
//             name={name}
//             onChange={handelChange}
//             onBlur={onBlur}
//           ></textarea>
//         </div>
//         <div className="textarea_upload_icon">
//           <input
//             type="file"
//             accept="image/*"
//             className="d-none"
//             ref={fileInputRef}
//             onChange={handleFileChange}
//             multiple
//           />
//           <label onClick={handleFileClick}>
//             <span className="attach_file_icon">
//               <img src={ImagesUrl.attachIcon} alt="Attach File" />
//             </span>

//             <span className="attch-text">
//               Attach File
//               {/* {files?.length > 0 ? (
//                 <div className="d-flex gap-1 flex-wrap">
//                   {Array.from(files).map((file, index) => (
//                     <div
//                       key={index}
//                       className="file-info d-flex justify-content-center align-items-center"
//                     >
//                       File: {file?.name ? file.name : file.split("/").pop()}
//                       <button className="remove_file">
//                         <img
//                           src={ImagesUrl.deleteIcon}
//                           alt="Trash"
//                           onClick={() => handleFileRemove(index, file)}
//                         />
//                       </button>
//                     </div>
//                   ))}
//                 </div>
//               ) : (
//                 "Attach File"
//               )} */}
//             </span>
//           </label>
//         </div>
//       </div>
//       <div className="file_img_preview_wrapper">
//         {Array.from(files).map((file, index) => (
//           <div className="new_file_preview_item" key={index}>
//             {file?.type ? (
//               <img
//                 src={
//                   file?.type === "application/pdf"
//                     ? ImagesUrl.pdfIcon
//                     : file?.type?.startsWith("image/")
//                     ? URL.createObjectURL(file)
//                     : ImagesUrl.defaultIcon
//                 }
//                 height="100"
//                 width="100"
//                 alt="Preview"
//               />
//             ) : (
//               <img
//                 src={
//                   file?.match(
//                     /\.(jpeg|jpg|png|gif|jfif|webp|bmp|tiff|tif|svg|ico|heic|heif)$/i
//                   )
//                     ? file
//                     : file?.match(/\.pdf$/i)
//                     ? ImagesUrl.pdfIcon
//                     : ImagesUrl.defaultIcon
//                 }
//                 alt="Preview"
//               />
//             )}

//             <button
//               className="remove_file"
//               onClick={() => handleFileRemove(index, file)}
//             >
//               <i className="fa fa-solid fa-xmark"></i>
//             </button>
//           </div>
//         ))}
//       </div>
//       {touched && error && (
//         <p style={{ color: "red", marginBottom: 0 }}>{error}</p>
//       )}
//     </>
//   );
// };

// export default FileAttachmentComponent;
import React from "react";
import ImagesUrl from "#constants/images.js";

const FileAttachmentComponent = ({
  label,
  files,
  fileInputRef,
  handleFileChange,
  handleFileClick,
  handleFileRemove,
  handelChange,
  name,
  placeholder,
  onBlur,
  value,
  touched,
  error,
  i,
}) => {
  return (
    <>
      <h3 className="fs-6 fw-medium mb-2">{label}</h3>
      <div className="mdl_custom_textarea_field">
        <div className="form-block">
          <textarea
            id="observation"
            className="form-control"
            placeholder={placeholder}
            value={value}
            name={name}
            onChange={handelChange}
            onBlur={onBlur}
          ></textarea>
        </div>
        <div className="textarea_upload_icon">
          <input
            type="file"
            accept="image/*"
            className="d-none"
            // ref={fileInputRef}
            onChange={(e) => handleFileChange(e, i)}
            ref={(el) => (fileInputRef.current[i] = el)}
            // onChange={(e) => handleObservationFileChange(e, i)}
            multiple
          />
          <label onClick={handleFileClick}>
            <span className="attach_file_icon">
              <img src={ImagesUrl.attachIcon} alt="Attach File" />
            </span>

            <span className="attch-text">Attach File</span>
          </label>
        </div>
      </div>
      <div className="file_img_preview_wrapper">
        {Array.from(files).map((file, index) => (
          <div className="new_file_preview_item" key={index}>
            {file?.type ? (
              <img
                src={
                  file?.type === "application/pdf"
                    ? ImagesUrl.pdfIcon
                    : file?.type?.startsWith("image/")
                    ? URL.createObjectURL(file)
                    : ImagesUrl.defaultIcon
                }
                height="100"
                width="100"
                alt="Preview"
              />
            ) : (
              <img
                src={
                  file?.match(
                    /\.(jpeg|jpg|png|gif|jfif|webp|bmp|tiff|tif|svg|ico|heic|heif)$/i
                  )
                    ? file
                    : file?.match(/\.pdf$/i)
                    ? ImagesUrl.pdfIcon
                    : ImagesUrl.defaultIcon
                }
                alt="Preview"
              />
            )}

            <button
              className="remove_file"
              onClick={() => handleFileRemove(index, file)}
            >
              <i className="fa fa-solid fa-xmark"></i>
            </button>
          </div>
        ))}
      </div>
      {touched && error && (
        <p style={{ color: "red", marginBottom: 0 }}>{error}</p>
      )}
    </>
  );
};

export default FileAttachmentComponent;
